import { render, staticRenderFns } from "./DocuEntryList.vue?vue&type=template&id=cc1c54d4&scoped=true&"
import script from "./DocuEntryList.vue?vue&type=script&lang=js&"
export * from "./DocuEntryList.vue?vue&type=script&lang=js&"
import style0 from "./DocuEntryList.vue?vue&type=style&index=0&id=cc1c54d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1c54d4",
  null
  
)

export default component.exports